export const urlToDataUri = async (url: string): Promise<string> => {
	const response = await fetch(url);
	const blob = await response.blob();
	return new Promise((resolve, reject) => {
		try {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onload = (e) => {
				const target = e.target as any;
				if (target) {
					return resolve(target.result.split(';base64,')[1]);
				}
			};
		} catch (e) {
			reject(e);
		}
	});
};
